var widget_default = {
  "card": "_56ka-",
  "link": "TP1WF",
  "container": "Ci9zz",
  "image": "VihRe",
  "right": "vYGGt",
  "cardLayout": "stkpO",
  "content": "aJ8eL",
  "title": "_2O2MX",
  "subtitle": "QylXb",
  "button": "_6Ym-2",
  "button_disabled": "Wafde",
  "buttonText": "Ysd6I",
  "slimLayout": "KKWxV",
  "contentText": "xkGEs"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
